if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.getElementById(this.dataset.buttonId);
        if (!this.mainButton) return;

        this.button = this.querySelector('.product-sticky-atc__button');
        this.footer = document.querySelector('.footer');
        this.frame = null;

        this.onClick = () => {
          const mainButton = document.getElementById(this.dataset.buttonId);
          if (mainButton && !mainButton.disabled) mainButton.click();
        };
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };

        this.button.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        this.stateObserver = new MutationObserver(() => this.sync());
        this.stateObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.sync();
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.stateObserver) this.stateObserver.disconnect();
      }

      sync() {
        const label = this.mainButton.querySelector('span');
        if (label) this.button.textContent = label.textContent.trim();
        this.button.disabled = this.mainButton.disabled;
        this.update();
      }

      update() {
        const pastMainButton = this.mainButton.getBoundingClientRect().bottom < 0;
        const footerVisible = this.footer ? this.footer.getBoundingClientRect().top < window.innerHeight : false;
        const visible = pastMainButton && !footerVisible && !this.mainButton.disabled;
        const previewBar = document.getElementById('PBarNextFrameWrapper');
        const previewBarHeight = previewBar ? previewBar.getBoundingClientRect().height : 0;

        this.style.bottom = previewBarHeight ? `${previewBarHeight}px` : '';
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
      }
    }
  );
}
